import './assets/styles/fonts.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MotorradHeader from './components/MotorradHeader';
import MotorradFooter from './components/MotorradFooter';
import Home from './pages/Home';
import Motorrad from './pages/Motorrad';
import AllMotoModels from './pages/AllMotoModels';
import Catalog from './pages/Catalog';
import Service from './pages/Service';
import Contacts from './pages/Contacts';

import MotorradServiceRequest from './pages/MotorradServiceRequest';
import MotorradTestDrive from './pages/MotorradTestDrive';

import ModelDetail from './pages/ModelDetail';

// Обертка для контента, чтобы иметь доступ к useLocation
const AppContent = () => {
  const location = useLocation();
  
  // 🔥 ОБНОВЛЕНО: Добавлена страница контактов в фильтр секции Motorrad
  const isMotorradSection = 
    location.pathname.startsWith('/') ||
    location.pathname === '/motorrad' || 
    location.pathname === '/moto_models' ||
    location.pathname === '/service-request' ||
    location.pathname === '/test-drive' ||
    location.pathname === '/contacts';

  return (
    <div className="app-container" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      
      {/* Условный рендеринг Хедера */}
      {isMotorradSection ? <MotorradHeader /> : <Header />}
      
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Motorrad />} />
          <Route path="/catalog/new" element={<Catalog type="new" />} />
          <Route path="/catalog/used" element={<Catalog type="used" />} />
          <Route path="/service" element={<Service />} />
          <Route path="/motorrad" element={<Motorrad />} />
          <Route path="/moto_models" element={<AllMotoModels />}/>
          <Route path="/service-request" element={<MotorradServiceRequest />} />
          <Route path="/test-drive" element={<MotorradTestDrive />} />
          <Route path="/motorrad/model/:id" element={<ModelDetail />} />
          <Route path="/contacts" element={<Contacts />} />
        </Routes>
      </main>

      {/* Условный рендеринг Футера */}
      {isMotorradSection ? <MotorradFooter /> : <Footer />} 
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;